import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"

export const autoEuropeSeasonSetsDrawerData = signal({})
export const autoEuropeSeasonSetsDrawerErrors = signal({})
export const autoEuropeSeasonSetsListData = signal([])
export const autoEuropeSeasonSetsIsLoading = signal(false)
export const autoEuropeSeasonSetsIsSubmitting = signal(false)

export const isAutoEuropeSeasonSetsDrawerOpen = computed(() =>
	autoEuropeSeasonSetsDrawerData.value && !isEmpty(autoEuropeSeasonSetsDrawerData.value)
)

export const clearAutoEuropeSeasonSetsSignals = () => batch(() => {
	autoEuropeSeasonSetsDrawerData.value = {}
	autoEuropeSeasonSetsDrawerErrors.value = {}
})
